import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { hasPrivilege, Privileged } from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import UserMemberAssignmentRow from './UserMemberAssignmentRow';
import { assignableMembersType, membersType } from '../../types';
import './_styles_/UserMemberAssignmentTable.css';
import useAuthentication from '../../hooks/useAuthentication';

UserMemberAssignmentTable.propTypes = {
    assignedMembers: membersType.isRequired,
    assignableMembers: assignableMembersType.isRequired,
    removeMemberAssignment: PropTypes.func.isRequired,
};

function UserMemberAssignmentTable(props) {
    const {
        assignedMembers,
        assignableMembers,
        removeMemberAssignment,
    } = props;
    const { t } = useTranslation();
    const { userPrivileges } = useAuthentication();
    const sufficientPrivileges = [Privileges.USER_EDIT];
    return (
        <div className="users-members--table detail-list">
            <div className="detail-list-row detail-list-header">
                <Privileged sufficientPrivileges={sufficientPrivileges}>
                    <div className="member-cell--small">&nbsp;</div>
                </Privileged>
                <div className="member-cell">{t('users.members.member-id')}</div>
                <div className="member-cell">{t('users.members.balancing-group')}</div>
                <div className="member-cell">{t('users.members.name')}</div>
                <div className="member-cell">{t('users.members.phone')}</div>
                <div className="member-cell">{t('users.members.emails')}</div>
            </div>
            {assignedMembers.map((assignedMember) => (
                <UserMemberAssignmentRow
                    key={assignedMember.memberId}
                    assignedMember={assignedMember}
                    isConflicting={hasPrivilege(userPrivileges, sufficientPrivileges) && !assignableMembers.some((assignableMember) => assignableMember.memberId === assignedMember.memberId)}
                    onRemoveMemberAssignment={removeMemberAssignment(assignedMember.memberId)}
                />
            ))}
        </div>
    );
}

export default UserMemberAssignmentTable;
